import React from 'react';

const BoldSvg = (props) => (
    <svg
        className="bold_svg__eds-icon--bold_svg"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            className="bold_svg__eds-icon--bold_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 12.8h4.7c3.2 0 5.2 1.1 5.2 3.6 0 2.3-1.5 3.5-4.7 3.5H8v-7.1zm0-8.7h4.6c3.2 0 4.7 1 4.7 3.3s-1.7 3.3-4.7 3.3H8V4.1zM13.4 22c4.4 0 6.9-2.1 6.9-5.5 0-2.9-1.9-4.4-4.3-4.9v-.1c2.1-.4 3.7-1.9 3.7-4.6 0-3.3-2.5-5-6.8-5H5.7v20h7.7z"
        />
    </svg>
);

BoldSvg.displayName = 'BoldSvg';
export default BoldSvg;
